import { SiretPipe } from 'pu-core-library';
import { OrganismeFormation } from '@features/referentiel/models/organisme-formation';
import { Statut } from '@shared/enums/entity.enum';

export class MonEtablissementForm {
  public siretFormated: string;
  public paymentDeadlineValue!: number;

  constructor(
    public identifiantTechnique: string = '',
    public opcoEpReference: string = '',
    public siret: string = '',
    public activityDeclarationNumber: string = '',
    public companyName: string = '',
    public adress: string = '',
    public postalCode: string = '',
    public municipality: string = '',
    public phoneNumber: string = '',
    public email: string = '',
    public assujetissementTVA: string = '',
    public tauxTVA: string | null = null,
    public numTvaIntracommunautaire: string = '',
    public paymentDeadline: string | null = null,
    public penaltyRate: number | null = null,
    public statut: string = '',
  ) {
    this.siretFormated = new SiretPipe().transform(this.siret).trim();
  }

  // Méthode statique pour convertir un objet OrganismeFormation en MonEtablissementForm
  static fromOrganismeFormation(organisme: OrganismeFormation): MonEtablissementForm {
    return new MonEtablissementForm(
      organisme.identifiantTechnique,
      organisme.referenceOpco,
      organisme.siret,
      organisme.numDeclarationActivite,
      organisme.raisonSociale,
      organisme.adresse,
      organisme.codePostal,
      organisme.ville,
      organisme.telephone,
      organisme.email,
      organisme.assujettissementTva,
      organisme.tauxTva?.replace('%',''),
      organisme.numTvaIntracommunautaire,
      MonEtablissementForm.formatDelaiPaiement(organisme.delaiPaiement),
      organisme.tauxPenalite,
      organisme.statut === Statut.enCoursDeFermeture
        ? 'En cours de fermeture dans notre référentiel'
        : organisme.statut,
    );
  }

  static formatDelaiPaiement(delaiPaiement?: string): string | undefined {
    return delaiPaiement ? `${delaiPaiement} jours` : delaiPaiement;
  }
}
